"use client";

import { useState } from "react";

interface ExpandableTextProps {
  text: string;
  maxLength?: number;
  className?: string;
}

export default function ExpandableText({
  text,
  maxLength = 300,
  className = "",
}: ExpandableTextProps) {
  const [expanded, setExpanded] = useState(false);

  if (text.length <= maxLength) {
    return <p className={className}>{text}</p>;
  }

  const truncateIndex = text.lastIndexOf(" ", maxLength);
  const truncated = text.slice(0, truncateIndex > 0 ? truncateIndex : maxLength);

  return (
    <p className={className}>
      {expanded ? text : `${truncated}...`}{" "}
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="inline text-blue-600 hover:text-blue-700 font-medium dark:text-blue-400 dark:hover:text-blue-300"
      >
        {expanded ? "Show less" : "Read more"}
      </button>
    </p>
  );
}
